module.exports = __webpack_public_path__ + "assets/img/event4.73555dd6.png";